import { createSelector } from 'reselect';

const selectSocialProfiles = (state: any) => state.socialProfiles;


export const selectSocialProfilesCurrentItem = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.current);

export const selectSocialProfilesListItems = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.list);

export const selectSocialProfilesItemById = (itemId: any) =>
    createSelector(selectSocialProfilesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSocialProfilesQueryItems = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.query);

export const selectSocialProfilesCreatedItem = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.create);

export const selectSocialProfilesUpdatedItem = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.update);

export const selectSocialProfilesReadItem = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.read);

export const selectSocialProfilesDeletedItem = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.delete);

export const selectSocialProfilesSearchedItems = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.search);

export const selectSocialProfilesItemsCount = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.count);

export const selectSocialProfilesItemsFilter = createSelector([selectSocialProfiles], (socialProfiles) => socialProfiles.filter);